import Job from '../../models/Job'
import { ApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface JobListState extends ApiState {
  jobs?: Job[]
}

export default requestReducer<JobListState>('JOB_LIST')